// Libs
import React, { Component } from 'react'
import _ from 'lodash'

// CSS
import "./styles.scss"

class Tag extends Component {
  state = {
    values: []
  }

  insertTag = (value) => {
    const { input } = this.props
    const { values } = this.state
    let newValues = [...values]

    if (newValues.indexOf(value) !== -1) {
      const index = newValues.indexOf(value);

      if (index > -1) {
        newValues.splice(index, 1)
      }
    } else {
      newValues = [...values, value]
    }

    if (!_.isEmpty(newValues)) {
      this.setState({ values: newValues })
      input.onChange(newValues)
    } else {
      this.setState({ values: newValues })
      input.onChange(null)
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { input } = this.props
    const { input: nextInput } = nextProps

    if (input.value && !nextInput.value) {
      this.setState({ values: [] })
    }
  }

  render() {
    const { input, meta: { touched, error }, options, type, label, placeholder, gutter, handleDelete } = this.props
    const { values } = this.state
    const { insertTag, isInserted } = this

    const tagStyle = {
      margin: `${gutter / 2}px 0px`
    }

    return (
      <div style={tagStyle} className="tag">
        <div className="tag__label">{label}</div>
        <div className="tag__bucket">
          {options.map(option => (
            <span
              {...input}
              key={option.value}
              className={
                values.indexOf(option.value) !== -1 ?
                  "tag__option tag__option--checked" :
                  touched && error ?
                    "tag__option tag__option--error" :
                    "tag__option"
              }
              onClick={() => insertTag(option.value)}>
              {option.label}
              {values.indexOf(option.value) !== -1 &&
                <i className="material-icons">close</i>
              }
            </span>
          ))}
        </div>
      </div>
    )
  }
}

export default Tag
